import { Field } from 'formik'
import React from 'react'

import { Fieldset, Input, Subsection, Textarea } from '@fourthwall/components'

import { SectionDescription } from '../SectionDescription/SectionDescription'
import { SocialImage } from '../SocialImage/SocialImage'

export const SiteDetails = () => (
  <Subsection title="Site details">
    <SectionDescription>
      Title and description appear on the browser window and search engines.
    </SectionDescription>
    <Fieldset>
      <Fieldset.Row>
        <Field
          name="name"
          component={Input}
          label="Site title"
          required
          maxLength={70}
          showCharacterCount
          fullWidth
        />
      </Fieldset.Row>

      <Fieldset.Row variant="large">
        <Field
          name="description"
          component={Textarea}
          label="Site description"
          placeholder="Site description"
          maxLength={320}
          required
          fullWidth
        />
      </Fieldset.Row>
      <Fieldset.Row>
        <SocialImage />
      </Fieldset.Row>
    </Fieldset>
  </Subsection>
)
